import {createContext} from 'react';
import type {FeaturesContextValue} from './types';

export const FeaturesContext = createContext<FeaturesContextValue | undefined>(
  undefined,
);
